export type AppProduct = 'ota' | 'notifications' | 'workspace';

export const appProductOrder: AppProduct[] = ['ota', 'notifications', 'workspace'];

export const appProductLabels: Record<AppProduct, string> = {
  ota: 'OTA',
  notifications: 'Notifications',
  workspace: 'Workspace'
};

export const appProductDescriptions: Record<AppProduct, string> = {
  ota: 'Release lanes, rollouts, and bundle delivery.',
  notifications: 'Messaging workflows and delivery automation.',
  workspace: 'Shared app shell, settings, and operator tools.'
};

export function normalizeAppProducts(
  values: Array<string | AppProduct> | undefined
): AppProduct[] {
  const selected = new Set((values || []).filter(
    (value): value is AppProduct =>
      appProductOrder.includes(value as AppProduct)
  ));
  const normalized = appProductOrder.filter((product) => selected.has(product));
  return normalized.length > 0 ? normalized : ['ota'];
}

export function primaryAppProduct(products: AppProduct[]) {
  return products[0] || 'ota';
}

export function appProductsLabel(products: AppProduct[]) {
  return products.map((product) => appProductLabels[product]).join(' · ');
}
